export default __webpack_public_path__ + "static/media/c11.de1bc0b6.PNG";